import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

import { environment } from './environments/environment';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
// Interceptores
import { netpayInterceptor } from './app/interceptors/netpay-interceptor';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// ⭐ NUEVO: Servicios de Audio Trigger
import { AudioTriggerService } from './app/pages/procedimientos/audioTrigger/audio-trigger.service';
import { SerialTriggerService } from './app/pages/procedimientos/audioTrigger/serial-trigger.service';
import { TriggerFactoryService } from './app/pages/procedimientos/audioTrigger/trigger-factory.service';

registerLocaleData(localeEsMx);

defineCustomElements(window);
if (environment.production) {
  enableProdMode();
} else {
  console.warn({ environment });
}

async function showTauriWindow() {
  // Verificar si estamos en Tauri
  if (typeof window !== 'undefined' && '__TAURI__' in window) {
    try {
      const { getCurrentWindow } = await import('@tauri-apps/api/window');
      const appWindow = getCurrentWindow();
      await appWindow.show();
      console.log('Ventana de Tauri mostrada correctamente');
    } catch (error) {
      console.error('Error al mostrar ventana de Tauri:', error);
    }
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, netpayInterceptor])),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    importProvidersFrom(
      BrowserAnimationsModule,
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      }),
    ),
    { provide: LOCALE_ID, useValue: 'es-MX' },

    // ⭐ NUEVO: Servicios de Audio Trigger
    AudioTriggerService,
    SerialTriggerService,
    TriggerFactoryService,
  ],
});
